module.exports = __webpack_public_path__ + "static/media/toilet90.831bf563.png";